"use strict";

var _topbar$clientHeight;
const elements = document.querySelectorAll("[data-observable]");
const callback = (entry, data, isIntersecting) => {
  switch (data) {
    case "fade-up":
      {
        if (!isIntersecting) break;
        entry.classList.add("visible");
        break;
      }
    case "fade-up-scroll-only":
      {
        if (!entry.classList.contains("fade-up-view")) {
          if (!isIntersecting) {
            entry.classList.add("fade-up-view");
          } else {
            entry.classList.add("opacity-100", "visible");
          }
        } else {
          entry.classList.add("visible");
        }
        break;
      }
    case "lazy-img":
      {
        if (!isIntersecting) break;
        entry.setAttribute("src", entry.getAttribute("data-src"));
        break;
      }
    case "fade-left-scroll-only":
      {
        if (!entry.classList.contains("fade-left-view")) {
          if (!isIntersecting) {
            entry.classList.add("fade-left-view");
          } else {
            entry.classList.add("opacity-100", "visible");
          }
        } else {
          entry.classList.add("visible");
        }
        break;
      }
    case "fade-in-children":
      {
        var _parseInt;
        if (!isIntersecting) break;
        let delay = (_parseInt = parseInt(entry.getAttribute("delay"))) !== null && _parseInt !== void 0 ? _parseInt : 800;
        if (isNaN(delay) || typeof delay !== "number" || delay <= 0) {
          delay = 800;
        }
        Array.from(entry.children).forEach((child, i) => {
          setTimeout(() => {
            child.classList.add("!opacity-100");
          }, delay * i + 300);
        });
        break;
      }
    case "count-up":
      {
        if (!isIntersecting) break;
        const countUp = entry => {
          if (typeof animateCountUp !== "undefined") {
            // eslint-disable-next-line no-undef
            animateCountUp(entry);
            return;
          }
          setTimeout(() => countUp(entry), 1000);
        };
        countUp(entry);
        break;
      }
    case "map":
      {
        if (!isIntersecting) break;
        if (!entry.hasAttribute("src")) {
          if (entry.parentElement.classList.contains("allowed")) {
            loadMap(entry);
          }
        }
        break;
      }
    case "recaptcha":
      {
        if (!isIntersecting) break;
        const modalElement = entry.closest("[modal]");
        if (modalElement) {
          const style = getComputedStyle(modalElement);
          if (style.display === "none" || style.opacity === "0" || style.visibility === "hidden") {
            console.debug("Modal is hidden, not loading reCAPTCHA");
            return;
          }
        }
        loadReCaptcha();
        break;
      }
    case "facebook":
      {
        if (!isIntersecting) break;
        loadFacebookScript();
        break;
      }
    default:
      {
        console.error("Unknown data-observable: ".concat(data));
        break;
      }
  }
};
const observer = new IntersectionObserver(handleIntersection);
elements.forEach(obs => {
  observer.observe(obs);
});
function handleIntersection(entries) {
  entries.forEach(entry => {
    callback(entry.target, entry.target.getAttribute("data-observable"), entry.isIntersecting);
  });
}

// eslint-disable-next-line no-unused-vars
const onScrollEvents = [];
let lastKnownScrollPosition = 0;
let ticking = false;
document.addEventListener("scroll", () => {
  lastKnownScrollPosition = window.scrollY;
  if (!ticking) {
    window.requestAnimationFrame(() => {
      // eslint-disable-next-line no-undef
      settings.onScroll.forEach(e => e(lastKnownScrollPosition));
      ticking = false;
    });
    ticking = true;
  }
});
const navbar = document.querySelector("nav");
const topbar = document.querySelector(".top-bar");
const positionTrigger = (_topbar$clientHeight = topbar === null || topbar === void 0 ? void 0 : topbar.clientHeight) !== null && _topbar$clientHeight !== void 0 ? _topbar$clientHeight : 0;
// eslint-disable-next-line no-undef
settings.onScroll.push(lastKnownScrollPosition => {
  navbar.classList[lastKnownScrollPosition > positionTrigger ? "add" : "remove"]("scrolled");
});
const openModal = modal => {
  var _document$querySelect;
  (_document$querySelect = document.querySelector("[modal=".concat(modal, "]"))) === null || _document$querySelect === void 0 || _document$querySelect.classList.add("visible");
  loadReCaptcha();
};
document.querySelectorAll("[modal]").forEach(modal => {
  modal.addEventListener("click", e => {
    if (e.target.hasAttribute("modal")) {
      modal.classList.remove("visible");
    }
  });
});
function toggleMobileMenuJs(open) {
  document.body.classList[open ? "add" : "remove"]("menu-open");
}
document.querySelectorAll(".sub-menu").forEach(menu => {
  menu.setAttribute("height", menu.offsetHeight);
  menu.classList.add("max-h-0");
  if (menu.parentElement.classList.contains("open")) {
    menu.style.maxHeight = "".concat(menu.getAttribute("height"), "px");
  }
});
document.querySelectorAll("[menu]").forEach(chevron => {
  chevron.addEventListener("click", () => {
    const open = document.querySelector(".menu-".concat(chevron.getAttribute("menu"))).classList.contains("open");
    const submenu = document.querySelector(".sub-menu-".concat(chevron.getAttribute("menu")));
    if (open) {
      document.querySelector(".menu-".concat(chevron.getAttribute("menu"))).classList.remove("open");
      submenu.style.maxHeight = "0px";
    } else {
      document.querySelector(".menu-".concat(chevron.getAttribute("menu"))).classList.add("open");
      submenu.style.maxHeight = "".concat(submenu.getAttribute("height"), "px");
    }
  });
});
let reCaptchaLoaded = false;
function loadReCaptcha() {
  if (reCaptchaLoaded) {
    console.debug("reCAPTCHA already loaded");
    return;
  }
  console.debug("Loading reCAPTCHA");
  reCaptchaLoaded = true;
  const recaptchaScript = document.createElement("script");
  recaptchaScript.src = "https://www.google.com/recaptcha/api.js?render=" + settings.v3public;
  recaptchaScript.defer = true;
  if (typeof Bugsnag !== "undefined") {
    Bugsnag.leaveBreadcrumb("Loading reCAPTCHA script");
  }
  recaptchaScript.onload = () => {
    grecaptcha.ready(function () {
      if (typeof Bugsnag !== "undefined") {
        Bugsnag.leaveBreadcrumb("reCAPTCHA ready");
      }
      document.querySelectorAll("button.recaptcha").forEach(button => {
        button.disabled = false;
      });
    });
  };
  document.body.appendChild(recaptchaScript);
}
let facebookScriptLoaded = false;
function loadFacebookScript() {
  if (facebookScriptLoaded) return;
  facebookScriptLoaded = true;
  const facebookScript = document.createElement("script");
  facebookScript.src = "https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v13.0";
  facebookScript.defer = true;
  facebookScript.crossOrigin = "anonymous";
  document.body.appendChild(facebookScript);
}
const slideSelectors = document.querySelectorAll(".slide-selectors > div");
const selectSelector = index => {
  slideSelectors.forEach(selector => selector.classList.remove("selected"));
  const slideSelector = document.querySelector(".slide-selector-".concat(index + 1));
  if (slideSelector) {
    slideSelector.classList.add("selected");
  }
};
let skipNextSlide = false;
const heroDelay = 3500;
function switchSlides(heroSlides) {
  heroSlides.forEach((slide, i) => {
    setTimeout(() => {
      slide.classList.remove("opacity-0");
      selectSelector(i);
      setInterval(() => {
        selectSelector(i);
        heroSlides.forEach(slide => slide.classList.add("opacity-0"));
        slide.classList.remove("opacity-0");
      }, heroSlides.length * heroDelay);
    }, i * heroDelay);
  });
}
const heroContainers = [...new Set([...document.querySelectorAll(".hero-slide")].map(slide => slide.parentElement))];

// Loop through each hero component and switch slides
heroContainers.forEach(heroContainer => {
  const heroSlides = heroContainer.querySelectorAll(".hero-slide");
  if (heroSlides.length > 1) {
    switchSlides(heroSlides);
  }
});
function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
function deleteCookie(name) {
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
}
const scrollIntoViewById = id => {
  const ids = id.split("||");
  for (const id of ids) {
    const element = document.querySelector("#".concat(id));
    if (element) {
      element.scrollIntoView({
        block: "start",
        behavior: "smooth"
      });
      return;
    }
  }
  throw new Error("Element with id (".concat(ids.join(", "), ") not found"));
};
const loadMap = mapElement => {
  mapElement.src = !mapElement.getAttribute("x-src").startsWith("http") ? "https://google.com/" : mapElement.getAttribute("x-src");
};
const isElementInViewport = el => {
  const rect = el.getBoundingClientRect();
  return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
};
const mobileMenu = document.querySelector(".mobile-menu");
const links = mobileMenu.querySelectorAll("a");
links.forEach(link => {
  link.addEventListener("click", e => {
    if (["use", "svg"].includes(e.target.tagName.toLowerCase())) {
      e.preventDefault();
      const parent = e.target.parentElement.parentElement;
      parent.classList.toggle("open");
    }
  });
});
const scrollElement = document.querySelector("#scroll-top");
const offset = 200;
if (scrollElement) {
  const updateScrollPercentage = () => {
    const getScrollPercentage = () => {
      const scrollTop = window.scrollY;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = window.innerHeight;
      const totalScrollableHeight = scrollHeight - clientHeight;
      if (totalScrollableHeight === 0) return 100; // In case the document is not scrollable

      const scrollPercentage = scrollTop / totalScrollableHeight * 100;
      return scrollPercentage;
    };
    const scrollTop = window.scrollY;
    const progress = getScrollPercentage();
    scrollElement.classList[scrollTop >= offset ? "add" : "remove"]("active");
    scrollElement.style.background = "conic-gradient(var(--color-scheme) 0% ".concat(progress, "%, transparent ").concat(progress, "% 100%)");
  };
  settings.onScroll.push(updateScrollPercentage);
  updateScrollPercentage();
  scrollElement.addEventListener("click", event => {
    event.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  });
}
const modals = document.querySelectorAll("[modal]");
modals.forEach(modal => {
  const modalId = modal.getAttribute("modal");
  const closeButton = modal.querySelector('[data-action="close"]');
  if (!closeButton) {
    console.error("Modal ID: ".concat(modalId, " is missing a close button"));
    return;
  }
  closeButton.addEventListener("click", () => {
    modal.classList.remove("visible");
  });
});
const animationDuration = 3000;
const frameDuration = 1000 / 60;
const totalFrames = Math.round(animationDuration / frameDuration);
const easeOutQuad = t => t * (2 - t);

// eslint-disable-next-line no-unused-vars
const animateCountUp = el => {
  let frame = 0;
  const countTo = parseInt(el.getAttribute("target"), 10);
  const currentValue = parseInt(el.innerHTML);
  if (currentValue > 0) {
    return;
  }
  const counter = setInterval(() => {
    frame++;
    const progress = easeOutQuad(frame / totalFrames);
    const currentCount = Math.round(countTo * progress);
    if (parseInt(el.innerHTML, 10) !== currentCount) {
      el.innerHTML = currentCount;
    }
    if (frame === totalFrames) {
      clearInterval(counter);
    }
  }, frameDuration);
};
const toggles = document.querySelectorAll(".menu-toggle");
toggles.forEach(toggle => {
  toggle.addEventListener("click", event => {
    const parentItem = toggle.closest(".menu-item");
    const expanded = toggle.getAttribute("aria-expanded") === "true";
    toggle.setAttribute("aria-expanded", !expanded);
    parentItem.classList.toggle("expanded", !expanded);
  });
});
//# sourceMappingURL=index.js.map